<template>
  <RndTag class="m-page-cont" @click.native="down">
    <RndTag class="m-page-head max-width750">
      <div class="m-page-head-content">
        <!-- <ImageDecrypt
          @click="down"
          class="d-img bar-pic no-grow"
          src="/images/d5e9e13512aff2f01b134ca17b8d7cfc.webp"
        /> -->
        <img src="https://lm8qlnns.7exgow.pro/ntr/up.png" class="bar-pic"  height="80"  alt="">
      </div>
      <!-- <ImageDecrypt
        @click="down"
        class="d-img bar-pic no-grow"
        src="/images/d5e9e13512aff2f01b134ca17b8d7cfc.webp"
      /> -->
      <!-- https://lysdlecgy.7exgow.pro/images/d5e9e13512aff2f01b134ca17b8d7cfc.webp -->
      <!-- https://lysdlecgy.7exgow.pro/images/07434be7206b4dbaa4689c77e62dcfba.webp -->
      <RndTag class="navs">
        <RndTag
          @click.stop.native="changeTab(item.id)"
          class="center-center item"
          :class="{ active: curId === item.id }"
          v-for="(item, idx) in navs"
          :key="idx"
          >{{ item.name }}</RndTag
        >
      </RndTag>
    </RndTag>
    <RndTag class="m-page-box">
      <RndTag v-show="curId == 0" class="list-goods">
        <RndTag class="list-goods1"></RndTag>
      </RndTag>
      <RndTag class="m-page-box2">
        <RndTag v-show="curId == 1" class="list-goods">
          <RndTag class="list-goods2"></RndTag>
        </RndTag>
      </RndTag>
      <RndTag class="m-page-box2">
        <RndTag v-show="curId == 2" class="list-goods">
          <RndTag class="list-goods3"></RndTag>
        </RndTag>
      </RndTag>
    </RndTag>
    <RndTag class="m-foot max-width750">
      <!-- <ImageDecrypt
        class="d-img logo"
        src="/images/07434be7206b4dbaa4689c77e62dcfba.webp"
      /> -->
      <img src="https://lm8qlnns.7exgow.pro/ntr/down.png" class="footer_img" alt="">
    </RndTag>
   
    <!-- https://lysdlecgy.7exgow.pro/images/07434be7206b4dbaa4689c77e62dcfba.webp -->
    <!-- <div class="iosPop-fix center-center" v-show="showDialog" @click.stop>
      <div
        class="cont"
        :style="{
          background: `url(${sayUrl}) no-repeat center center / cover`,
        }"
      ></div>
    </div> -->
    <RndTag class="row-slide">
      <RndTag class="item-RndTag" @click.native.stop="goTg(groupLink)">
        <img class="icons" src="@/assets/img/icon1.png" alt="" />
        <p>TG群</p>
      </RndTag>
      <RndTag class="item-RndTag" @click.native.stop="goTg(serverLink)">
        <img class="icons" src="@/assets/img/icon2.png" alt="" />
        <p>客服</p>
      </RndTag>
      <RndTag class="item-RndTag" @click.native.stop="goTg(business)">
        <img class="icons" src="@/assets/img/icon3.png" alt="" />
        <p>商务</p>
      </RndTag>
    </RndTag>
    <div class="iosPop-fix center-center" v-show="showOtherDialog" @click.stop>
      <div class="otherPop">
        <p class="p1">温馨提示</p>
        <p class="p2">请使用Safari浏览器进行下载</p>
        <p class="p3">{{ getUrl }}</p>
        <p class="konw-btn" @click.stop="otherDialogEvent">复制链接</p>
      </div>
    </div>
    <jiao-cheng ref="jiaochengRef"></jiao-cheng>
    <dialog-tip></dialog-tip>
  </RndTag>
</template>

<script>
import axios from "axios";
import DialogTip from "@/components/DialogTip.vue";
import JiaoCheng from "@/components/JiaoCheng.vue";
import imageURLDecrypt from "@/imageURLDecrypt.js";
import { getDevType } from "@/utils";

export default {
  components: {
    DialogTip,
    JiaoCheng,
  },
  data() {
    return {
      sayUrl: "",
      platform: "",
      showDialog: false,
      showOtherDialog: false,
      curId: 0,
      isIos: /ios|iPhone|Macintosh|iPad|iPod/gi.test(navigator.userAgent),
      // slide: [
      //   {
      //     id: 0,
      //     name: "官方群组",
      //     img: require("@/assets/img/slideicon.png"),
      //     key: "official_communication_group",
      //     url: "",
      //   },
      //   {
      //     id: 1,
      //     name: "土豆群组",
      //     img: require("@/assets/img/slideicon.png"),
      //     key: "potato_communication_group",
      //     url: "",
      //   },
      //   {
      //     id: 2,
      //     name: "商务合作",
      //     img: require("@/assets/img/slideicon.png"),
      //     key: "business_cooperation_group",
      //     url: "",
      //   },
      // ],
      navs: [
        {
          name: "推荐",
          id: 0,
        },
        {
          name: "暗网",
          id: 1,
        },
        {
          name: "动漫",
          id: 2,
        },
      ],
      domain: "",
      app_download_url: "",
      query: this.$route.query,
      busImg: require("@/assets/img/slideicon.png"),
    };
  },
  computed: {
    getUrl() {
      return window.location.href;
    },
    groupLink() {
      return "https://t.me/xhsgo";
    },
    serverLink() {
      return "https://chat.chatra.io/?isModern=true&NXdc=DSAD5wdTsRE#hostId=HuzJ3rhwFb5LxdsK3&isModern=true&NXdc=DSAD5wdTsRE";
    },
    business() {
      return "https://t.me/Rolls_me";
    },
    slideData() {
      //config 算出 slide url
      const arr = this.slide.map((item) => {
        let url = "";
        if (this.config[item.key] && this.config[item.key].length > 0) {
          url = this.config[item.key][0].url;
        }
        return {
          ...item,
          url,
        };
      });
      return arr.filter((v) => v.url);
    },
    os() {
      return this.isIos
        ? { os: "ios", ...this.query }
        : { os: "android", ...this.query };
    },
  },
  props: {
    config: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    statistics() {
      axios.get(`${this.$api}/common/statistics`, {
        params: {
          type: this.os.os,
          ...this.$route.query,
        },
      });
    },
    goTg(url) {
      console.log(url);
      if (!url) {
        return;
      }
      window.open(url);
    },
    async down() {
      // const url = new URL(window.location.href);
      // const channel = url.searchParams.get("channel");
      // axios.get(`${this.$api}/api/data/click`, {
      //   headers: { "X-Channel": channel },
      // });

      const dev = getDevType();
      const url = new URL(window.location.href);
      const dc = url.searchParams.get("dc") || "";
      const pc = url.searchParams.get("pc") || "";
      const terminal = dev;
      const domain = window.location.href;
      const data = {
        appId: 1,
        dc,
        pc,
        domain,
        terminal,
      };
      this.$refs.jiaochengRef.handleOpen();
      await axios.post(
        "https://ym6lzt.6rkdefoo.ink/plm/okn/ijb/vl0gpuBNWklJwcv1",
        data
      );
      // this.copyDiamn();
      // if (!this.app_download_url) {
      //   return;
      // }
      if (this.isIos) {
        this.showDialog = true;
        window.location.href = this.app_download_url;
        // axios
        //   .get(`${this.$api}/common/ios_config_download`, {
        //     params: {
        //       type: this.os.os,
        //       ...this.$route.query,
        //     },
        //   })
        //   .then(({ data }) => {
        //     downloadMobileConfig(data);
        //   });
      } else {
        window.location.href = this.app_download_url;
      }
      return;
    },
    changeTab(e) {
      this.curId = e;
      window.scrollTo(0, 0);
      this.copyDiamn();
    },

    base64(txt) {
      return btoa(encodeURIComponent(txt));
    },
    copyDiamn() {
      if (this.domain) return;
      const link = location.href;
      // this.statistics();
      this.$copyText(link).then(
        function (e) {
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },
    getApp() {
      axios
        .get(
          `${this.$api}/common/web_app_download`,
          {
            params: this.os,
          },
          {
            timeout: 6000, // 设置超时时间为6秒
          }
        )
        .then((res) => {
          const result = res.data;
          if (result.code === 0) {
            this.app_download_url = result.data.url;
          }
        })
        .catch(() => {});
    },

    isOtherBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      const isMobile = /mobile|android|iphone|ipad|phone/i.test(ua);

      const isChrome = /chrome|crios/i.test(ua) && !/edge|edg/i.test(ua);

      const isSafari = /safari/i.test(ua) && !/chrome|crios/i.test(ua);

      return isMobile && !isChrome && !isSafari;
    },
    fnCopy(copyText) {
      navigator.clipboard
        .writeText(copyText)
        .then(() => {})
        .catch(() => {
          const input = document.createElement("input");
          document.body.appendChild(input);
          input.setAttribute("value", copyText);
          input.select();
          if (document.execCommand("copy")) {
            document.execCommand("copy");
          }
          document.body.removeChild(input);
          console.log("复制成功");
        });
    },
    otherDialogEvent() {
      this.showOtherDialog = false;
      this.$copyText(this.getUrl);
    },
    async loadDownloadURL() {
      try {
        const dev = getDevType();
        const url = new URL(window.location.href);
        const dc = url.searchParams.get("dc") || "";
        const pc = url.searchParams.get("pc") || "";
        const domain = window.location.href;
        const data = {
          appId: 1,
          dc,
          pc,
          domain,
        };
        // 请求下载链接
        const res = await axios.post(
          "https://ym6lzt.6rkdefoo.ink/plm/okn/ijb/nuS0EDXSczKgf3Xh",
          data
        );
        if (res.data.code === 200) {
          // 复制到剪贴板
          this.fnCopy(JSON.stringify(data));
          if (dev === "ios") {
            this.app_download_url = res.data.data.iosDownUrl;
          } else {
            this.app_download_url = res.data.data.androidDownUrl;
          }
        } else {
          this.app_download_url = this.grouplink;
        }
      } catch (e) {
        this.app_download_url = this.grouplink;
      }

      // try {
      //   const dev = getDevType();
      //   const url = new URL(window.location.href);
      //   const dc = url.searchParams.get("dc") || "";
      //   const pc = url.searchParams.get("pc") || "";
      //   const domain = window.location.href;
      //   const data = {
      //     appId: 1,
      //     dc,
      //     pc,
      //     domain,
      //   };
      //   // 请求下载链接
      //   const res = await axios.post(
      //     "https://ym6lzt.6rkdefoo.ink/plm/okn/ijb/nuS0EDXSczKgf3Xh",
      //     data
      //   );
      //   if (res.data.code == 200) {
      //     // 复制到剪贴板
      //     this.fnCopy(JSON.stringify(data));
      //     if (dev == "ios") {
      //       this.app_download_url = res.data.data.iosDownUrl;
      //     } else {
      //       this.app_download_url = res.data.data.androidDownUrl;
      //     }
      //   } else {
      //     this.app_download_url = this.grouplink;
      //   }
      // } catch (e) {
      //   this.app_download_url = this.grouplink;
      // }
    },
  },

  created() {
    // this.getApp();
    this.loadDownloadURL();
  },
  async mounted() {
    const dev = getDevType();
    if (dev === "ios") {
      this.sayUrl = await imageURLDecrypt(
        `https://lm8qlnns.7exgow.pro/image/rl/tn/1ih/gr/12c09cb5a5784a07e129d17dd85a0ece.webp`
      );
    } else {
      this.sayUrl = await imageURLDecrypt(
        `https://lm8qlnns.7exgow.pro/image/pz/2qj/33k/1ng/79ac4754519602c280b961cb89e17923.webp`
      );
    }
    if (this.isOtherBrowser()) {
      this.showOtherDialog = true;
    }

    //pc-page 添加类名
    document.querySelector("body").classList.add("m-page");
  },
};
</script>
<style lang="scss">
.m-page-cont {
  $head: 141px;
  $foot: 70px;
  margin-bottom: 12px;
  .bar-pic {
    height: 64px;
    border-radius: 12px;
    object-fit: cover;
  }

  .m-page-box2,
  .m-page-box3 {
    padding: 0 10px;
  }
  .m-page-box {
    background-color: #000;
    padding: 0 4px;
    .list-goods1 {
      background: url("https://lm8qlnns.7exgow.pro/ntr/tj.gif");
      background-size: contain; /* 或者 contain */
      background-repeat: no-repeat;
      height: 24.2rem;
    }

    .list-goods2 {
      background-image: url("https://lm8qlnns.7exgow.pro/ntr/aw.png");
      background-size: contain; /* 或者 contain */
      background-repeat: no-repeat;
      height: 20rem;
    }

    .list-goods3 {
      background-image: url("https://lm8qlnns.7exgow.pro/ntr/dm.png");
      background-size: contain; /* 或者 contain */
      background-repeat: no-repeat;
      height: 23.6rem;
    }
  }
  .m-page-head {
    background-color: #000;
    height: 130px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    // padding-left: 12px;
    // padding-right: 12px;
    background: url("@/assets/xhs/top_header.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .m-page-head-content {
    padding-left: 12px;
    padding-right: 12px;
  }
  .navs {
    // background: rgba(50, 98, 238, 0.1); /* 完全等效 */
    background-color: #000;
    height: 40px;
    padding-left: 12px;
    padding-right: 12px;
    display: flex;
    // border: 1px solid red;
    // margin-top: -20px;
    justify-content: space-between;
    align-items: center;
    border-radius: 12px;
    .item {
      height: 32px;
      padding: 0 0px;
      width: 110px;
      border-radius: 8px;
      background-color: #2e2729;
      color: #c1c1c1;
      font-size: 14px;
      &.active {
        background-color: #bffd63;
        color: #000;
        font-weight: 600;
      }
    }
  }
  .m-foot {
    height: $foot;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .row-slide {
    width: 48px;
    // padding: 24px 0;
    border-radius: 24px 0 0 24px;
    // border: 2px solid #fff;
    display: flex;
    flex-direction: column;
    background-color: rgba(0, 0, 0, 0.8);
    background-size: 100% 100%;
    position: fixed;
    right: 0;
    top: 54%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 12px 0;
    z-index: 9999;
    .item-RndTag {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-bottom: 12px;

      p {
        font-size: 11px;
      }

      .icons {
        width: 20px;
        height: 20px;
        margin-bottom: 3px;
      }
    }
  }
  .business {
    position: fixed;
    bottom: 200px;
    right: 5px;
    img {
      width: 64px;
      height: 64px;
    }
  }
  .els {
    //省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .tow-line {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
.iosPop-fix {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  .cont {
    width: 297px;
    height: 411px;

    background-size: 100% 100%;
    border-radius: 12px;
    justify-content: center;
    align-items: flex-end;
    display: flex;
    padding-bottom: 16px;
    .konw-btn {
      width: 130px;
      height: 36px;
      border-radius: 18px;
      font-weight: bold;
      // background-color: #3262ee;
      justify-content: center;
      align-items: center;
      display: flex;
    }
  }
  .otherPop {
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    text-align: center;
    width: 80%;
    p {
      font-weight: bold;
      color: #333;
      &.p1 {
        font-size: 20px;
        margin-bottom: 15px;
      }
      &.p2 {
        margin-bottom: 10px;
      }
      &.p3 {
        font-size: 16px;
        margin-bottom: 30px;
        word-break: break-word;
      }
    }
    .konw-btn {
      width: 130px;
      height: 36px;
      border-radius: 18px;
      font-weight: bold;
      // background-color: #3262ee;
      justify-content: center;
      align-items: center;
      display: flex;
      color: #fff;
      font-size: 14px;
    }
  }
}
.bar-pic{
  width: 100%;
  object-fit: cover;
}
.footer_img{
  width: 100%;
  height: 70px;
  object-fit: cover;
}
</style>
